import React, {useEffect, useRef} from "react";
import {storeUser} from "../Redux/Actions/authActions";
import {setAuthHeader} from "../Axios/axiosHeaders";
import signinManager from "./authService";
import {User} from "oidc-client";
import {IAuthProvider} from "../Interfaces/IAuthProvider";
import { consolelog } from "../helpers/consolelog";

export const AuthProvider: React.FC<IAuthProvider> = ({manager, store, children}) => {
  const userManager = useRef(manager)

  useEffect(() => {

    const onUserLoaded = (user: User) => {
      consolelog(`user loaded: ${user}`)
      store.dispatch(storeUser(user))
    }

    const onUserUnloaded = () => {
      setAuthHeader(null)
      consolelog(`user unloaded`)
    }

    // var data = await signinManager.signinSilentCallback();
    // consolelog(data);

    const onAccessTokenExpiring = async () => {
      consolelog(`user token expiring`)
      try {
        signinManager
        .signinSilent()
        .then((user) => {
          consolelog("user", user)
          store.dispatch(storeUser(user))
          setAuthHeader(user.access_token)
        })
        .catch(async (error) => {
          consolelog("error:", error)
        });
      } catch (error) {
        consolelog(error)
      }
    };

    const onAccessTokenExpired = async () => {
      consolelog(`user token expired`)
      await signinManager.signoutRedirect()
    };

    const onUserSignedOut = () => {
      consolelog(`user signed out`);
    }

    // events for usersss
    if (userManager !== undefined) {
      userManager?.current.events.addUserLoaded(onUserLoaded);
      userManager?.current.events.addUserUnloaded(onUserUnloaded);
      userManager?.current.events.addAccessTokenExpiring(onAccessTokenExpiring);
      userManager?.current.events.addAccessTokenExpired(onAccessTokenExpired);
      userManager?.current.events.addUserSignedOut(onUserSignedOut);
    }


    // Specify how to clean up after this effect
    return function cleanup() {
      userManager.current.events.removeUserLoaded(onUserLoaded);
      userManager.current.events.removeUserUnloaded(onUserUnloaded);
      userManager.current.events.removeAccessTokenExpiring(onAccessTokenExpiring);
      userManager.current.events.removeAccessTokenExpired(onAccessTokenExpired);
      userManager.current.events.removeUserSignedOut(onUserSignedOut);
    };
  }, [userManager, store]);

  return React.Children.only(children);
}

export default AuthProvider;